<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "UsersModule"
    }
</script>

<style scoped>

</style>
